import React, { useEffect } from "react";
import {
  Accordion,
  AccordionHeader,
  AccordionItem,
  AccordionPanel,
  AccordionToggleEventHandler,
  Body1,
  Body1Strong,
  makeStyles,
  tokens,
} from "@fluentui/react-components";
import { useOfficeItem } from "../../../providers";
import { CalendarDayRegular, ErrorCircleRegular } from "@fluentui/react-icons";
import { msGraphService } from "../../../services";
import { logger } from "../../../utils";
import { envUtils } from "../../../utils/envUtils";

const useStyles = makeStyles({
  body: {
    display: "flex",
    flexDirection: "column",
    gap: "5px",
    marginTop: "35px",
  },
  panel: {
    display: "flex",
    flexDirection: "column",
    gap: "5px",
    padding: "0 5px",
    height: "250px",
    overflowY: "auto",
  },
  row: {
    display: "flex",
    flexDirection: "row",
    gap: "5px",
    marginBottom: "5px",
  },
  event_details: {
    wordBreak: "break-all",
  },
});

const MainEventDetails = () => {
  // used to style the component
  const styles = useStyles();

  // indicates the current event
  const { event, isLoading, isFetching, error, isError } = useOfficeItem();

  return envUtils.RELEASE_TYPE === "development" && event && !isLoading && !isFetching ? (
    <div className={styles.body}>
      <Accordion collapsible>
        <AccordionItem value="1">
          <AccordionHeader
            icon={
              isError ? (
                <ErrorCircleRegular color={tokens.colorPaletteRedForeground1} />
              ) : (
                <CalendarDayRegular color={tokens.colorPaletteGreenForeground1} />
              )
            }
          >
            Current Outlook Meeting Data
          </AccordionHeader>
          <AccordionPanel>
            {isError ? (
              <div className={styles.panel}>
                <Body1 wrap={true} color={tokens.colorPaletteRedForeground1}>
                  {error ? error : "An error occurred while fetching the event data."}
                </Body1>
              </div>
            ) : (
              <div className={styles.panel}>
                {Object.keys(event).map((key) => (
                  <div key={key} className={styles.row}>
                    <Body1Strong>{key.charAt(0).toUpperCase() + key.slice(1)}:</Body1Strong>
                    <Body1 wrap={key === "id"} className={styles.event_details}>
                      {event[key as keyof typeof event] instanceof Date
                        ? (event[key as keyof typeof event] as Date).toLocaleString()
                        : String(event[key as keyof typeof event] ?? "not set")}
                    </Body1>
                  </div>
                ))}
              </div>
            )}
          </AccordionPanel>
        </AccordionItem>
      </Accordion>
    </div>
  ) : null;
};

export default MainEventDetails;
